<template>
  <div class="w-full text-left" v-if="jobs">
  <div class="relative pb-5 border-b border-gray-200 sm:pb-0 px-5 mt-5">
    <div class="md:flex md:items-center md:justify-between">
      <h3 class="text-lg leading-6 font-medium text-gray-900">
        Jobs
      </h3>
      <div class="mt-3 flex md:mt-0 md:top-3 md:right-0">
        <button v-if="user.type!='cleaner'" type="button" class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" @click="goto('/jobs/create')">
          Create new
        </button>
      </div>
    </div>
    <div class="mt-4">
      <div class="sm:hidden">
        <label for="current-tab" class="sr-only">Select a tab</label>
        <select   id="current-tab" name="current-tab" class="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md" @change="onChange($event.target.selectedIndex)">
          <option v-for="(tab, index) in tabs" :key="tab.name" :selected="tab.current">{{ tab.name }} ({{jobCount(index)}})</option>
        </select>
      </div>
      <div class="hidden sm:block">
        <nav class="-mb-px flex space-x-8 items-center">
          <div class="flex-grow">
            <a v-for="(tab, index) in tabs" :key="tab.name" :class="[tab.current ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm cursor-pointer']" @click="onChange(index)">
              {{ tab.name }}
              <span class="bg-indigo-100 text-indigo-600 hidden ml-2 py-0.5 px-2.5 rounded-full text-xs font-medium md:inline-block">{{jobCount(index)}}</span>
            </a>
          </div>
        </nav>
      </div>
      <div v-if="studios.length > 1" class="hidden sm:block">
        <nav class="-mb-px flex space-x-8">
          <!-- Navbar contents... -->
          <div class="flex items-center space-x-2 ml-auto">
            <span class="text-sm font-medium text-gray-500">Filter Studio</span>
            <select v-model="selectedStudio" class="block w-48 pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
              <option value="">All</option>
              <option v-for="studio in studios" :key="studio._id" :value="studio._id">{{ studio.description }}</option>
            </select>
          </div>
        </nav>
      </div>
      <!-- The version for smaller screens -->
      <div v-if="studios.length > 1" class="block sm:hidden p-4">
        <span class="text-sm font-medium text-gray-500">Filter Studio</span>
        <select v-model="selectedStudio" class="block w-full pl-3 pr-10 py-2 text-base border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
          <option value="">All</option>
          <option v-for="studio in studios" :key="studio._id" :value="studio._id">{{ studio.description }}</option>
        </select>
      </div>
    </div>
  </div>
          <div class="text-center mt-6" v-if="filteredJobs.length < 1">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
        <path vector-effect="non-scaling-stroke" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
      </svg>
      <h3 class="mt-2 text-sm font-medium text-gray-900">No Jobs</h3>
      <p class="mt-1 text-sm text-gray-500">
        There are no current {{currentTab}} jobs available. <br>Come back later.
      </p>
    </div>
    <div v-if="filteredJobs.length > 0" class="bg-white overflow-hidden shadow sm:rounded-md xl:mt-5">
      <ul class="divide-y divide-gray-200">
        <li
          v-for="(job) in filteredJobs"
          :key="job._id"
          @click="goto('/jobs/' + job._id)"
        >
          <a class="block hover:bg-gray-50 cursor-pointer">
            <div class="px-4 py-4 flex items-center sm:px-6">
              <div
                class="min-w-0 flex-1 sm:flex sm:items-center sm:justify-between"
              >
                <div class="truncate">
                  <div class="flex text-sm">
                    <p class="font-medium text-indigo-600 truncate">
                      Job
                    </p>
                    <p class="ml-1 flex-shrink-0 font-normal text-gray-500">
                      for {{ job.studio.description }} at {{ job.studio.street }}, {{ job.studio.city }}
                    </p>
                  </div>
                  <div class="mt-2 flex">
                    <div class="flex items-center text-sm text-gray-500">
                      <!-- Heroicon name: solid/calendar -->
                      <svg
                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
                          clip-rule="evenodd"
                        />
                      </svg>
                      <p>
                        Closing on
                        <time>{{ job.dateOfJob | moment('timezone', 'Europe/Brussels',"dddd, MMMM Do YYYY") }}</time>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="ml-5 flex-shrink-0">
                <!-- Heroicon name: solid/chevron-right -->
                <svg
                  class="h-5 w-5 text-gray-400"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                    clip-rule="evenodd"
                  />
                </svg>
              </div>
            </div>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const tabs = [
  { name: 'Open', slug: 'open', current: true },
  { name: 'In Progress', slug: 'accepted', current: false },
  { name: 'Finished', slug: 'finished', current: false },
]
export default {
  name: "Dashboard",
  components: {},
  data() {
    return {
      tabs,
      currentTab: 'open',
      selectedStudio: '', 
    };
  },
  beforeCreate() {
    this.$store.dispatch("job/getJobs");
  },
  beforeDestroy() {
    this.onChange(0)
  },
  computed: {
    ...mapGetters("user", {
      user: "currentUser",
    }),
    ...mapGetters("job", {
      jobs: "jobList",
    }),
    ...mapGetters("studio", { 
    studios: "studioList", 
    }),
    filteredJobs() {
      return this.filterJobsByStatus(this.currentTab);
    },
    currentTabC(){
      return tabs.filter((i) =>{
        return i.current
      });
    }
  },
  methods: {
    deleteJob(id) {
      this.$store.dispatch("job/deleteJob", id);
    },
    goto(path) {
      this.$router.push({ path });
    },
    onChange(index){
      this.tabs.forEach(tab => {
        tab.current=false
      });
      this.tabs[index].current = true;
      this.currentTab = this.tabs[index].slug
    },
    filterJobsByStatus(status) {
        const cleanerId = this.user.id;
        return this.jobs.filter((job) => {
            return (job.status == status 
                    && job.studio && (this.selectedStudio === '' || job.studio._id === this.selectedStudio)
                    && (!job.rejectedCleaners || !job.rejectedCleaners.includes(cleanerId)));
        });
    },
    jobCount(index){
      return this.filterJobsByStatus(this.tabs[index].slug).length;
    }
  },
};
</script>

<style lang="css" scoped>
</style>